<div class="row">
    <div class="col-md-12 text-center">


        <div class="centered-container">
            <div class="centered-content">
                <div class="row mt-5">
                    <div class="col-md-12">
                        <img src="../../../assets/easy_assets/dashboard logo.png" alt="" style="width: auto;">
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-md-12">

                        @if (!isFailed) {
                        <div class="spinner-border text-primary" role="status">
                            <span class="sr-only">Loading...</span>

                        </div>
                        <p>Authenticating, please wait...</p>
                        }@else{
                        <button mat-flat-button color="primary" class="auth-form-btn" type="submit">Login</button>
                        }


                    </div>
                </div>
            </div>
        </div>
    </div>